import { Box, Container, Typography } from "@mui/material";
import type { GridColDef } from "@mui/x-data-grid-premium";
import DataGrid from "@entrilia/shared/components/grid/DataGrid";
import type { DataModelConfiguration } from "../../../../api/types/dataModelConfigurationTypes";
import { useObjectDefinitionContext } from "../ObjectDefinitionContext";
import { EditLayoutLink } from "./objectLayoutsGridProvider";

const columnDefinitions: GridColDef<DataModelConfiguration>[] = [
  {
    field: "name",
    headerName: "Configuration Name",
    flex: 2,
  },
  {
    field: "clientCodes",
    headerName: "Companies",
    flex: 1,
    valueGetter: (_, row) => row.clientCodes.length || "None",
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 150,
    cellClassName: "grid-row-actions",
    align: "right",
    headerAlign: "right",
    renderCell: ({ row }) => <EditLayoutLink configurationId={row.id} />,
  },
];

const ObjectLayouts = () => {
  const { configurations } = useObjectDefinitionContext();

  return (
    <Container maxWidth="md" disableGutters sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2.5 }}>
        <Typography color="textSecondary">Customize layouts for different companies in the organization.</Typography>
      </Box>
      <DataGrid<DataModelConfiguration>
        columns={columnDefinitions}
        rows={configurations}
        noRowsText="No configurations yet"
        disableColumnReorder
        disableColumnSorting
        disableMultipleRowSelection
      />
    </Container>
  );
};

export default ObjectLayouts;
